module.exports = __webpack_public_path__ + "static/media/amanda-queiroz.54247b24.jpeg";